import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { sendApiRequest } from '../../utils';
import { toast } from 'react-toastify';
import { FiPrinter, FiArrowLeft, FiDownload, FiSearch, FiChevronLeft, FiChevronRight, FiFileText } from 'react-icons/fi';
import { CSVLink } from 'react-csv';
import logo from '../../assets/images/logo.png';
import { useSelector } from 'react-redux';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FaRupeeSign } from "react-icons/fa";
import './print.css';

const companyInfo = {
  name: 'Prayag Properties & Mishra Construction',
  division: '',
  address: '567, Shaha Urf Pipalgaon, Near IIIT- A Chauraha, Jhalwa, Prayagraj 211012',
  phone: '',
  email: 'prayagproperties2020@gmail.com',
  invoiceLabel: 'BOOKING INVOICE',
};

const ViewPackageReceipt = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [receipts, setReceipts] = useState([]);
  const [commisionReceipts, setCommisionReceipts] = useState([]);
  const [filteredReceipts, setFilteredReceipts] = useState([]);
  const [selectedReceipt, setSelectedReceipt] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [receiptsPerPage] = useState(50);
  const [monthFilter, setMonthFilter] = useState('');
  const [yearFilter, setYearFilter] = useState('');
  const [csvData, setCsvData] = useState([]);
  const [detailedReceipt, setDetailedReceipt] = useState(null);
  const userData = useSelector(state => state.user_info[0]?.user);
  const paymentReceiptFromOnce = localStorage.getItem('paymentReceiptFromOnce');

  const queryParams = new URLSearchParams(location.search);
  const receiptId = queryParams.get('receiptId');

  useEffect(() => {
    fetchReceiptDetails();
  }, []);
  useEffect(() => {
    handleSelectReceipt();
  }, [paymentReceiptFromOnce]);

  async function getReceiptWithID() {
    const data = await fetchReceiptDetailsCommision(receiptId)
    if (data) {
      handleSelectReceipt(data[0]);
    }
  }

  useEffect(() => {
    if (receiptId) {
      getReceiptWithID(receiptId)
    }
  }, [receiptId]);

  useEffect(() => {
    if (searchTerm) {
      const filtered = filterReceipts(receipts);
      setFilteredReceipts(filtered);
      setCurrentPage(1);
    } else {
      setFilteredReceipts(receipts);
    }
  }, [searchTerm, monthFilter, yearFilter, receipts]);

  const prepareCSVData = (receipts) => {
    return receipts.map(receipt => ({
      'Receipt Number': receipt.receiptNumber || 'N/A',
      'Date': new Date(receipt.receiptDate).toLocaleDateString(),
      'Customer Name': receipt.customer?.customerName || 'N/A',
      'Customer Phone': receipt.customer?.customerPhone || 'N/A',
      'Package': receipt.package?.title || 'N/A',
      'Amount': `₹${receipt.amount?.toLocaleString('en-IN') || '0'}`,
      'Payment Mode': receipt.paymentMode || 'N/A',
      'Status': receipt.status || 'N/A'
    }));
  };

  useEffect(() => {
    const filtered = filterReceipts(receipts);
    setFilteredReceipts(filtered);
    setCsvData(prepareCSVData(filtered));
    setCurrentPage(1);
  }, [searchTerm, monthFilter, yearFilter, receipts]);

  const filterReceipts = (receipts) => {
    return receipts.filter(receipt => {
      // Apply month and year filter if set
      if (monthFilter || yearFilter) {
        const receiptDate = new Date(receipt.receiptDate);
        const receiptMonth = receiptDate.getMonth() + 1; // getMonth() is 0-indexed
        const receiptYear = receiptDate.getFullYear();

        if (monthFilter && parseInt(monthFilter) !== receiptMonth) {
          return false;
        }
        if (yearFilter && parseInt(yearFilter) !== receiptYear) {
          return false;
        }
      }

      // Apply search term filter if set
      if (searchTerm) {
        const customerName = receipt.customer?.customerName?.toLowerCase() || '';
        const receiptNumber = receipt.receiptNumber?.toLowerCase() || '';
        const amount = receipt.amount.toString();
        const partnerName = receipt.partner?.fullName?.toLowerCase() || '';
        const date = receipt.receiptDate?.split('T')[0] || ''; // "2025-06-11"

        const searchTermLower = searchTerm.toLowerCase();

        return (
          // Customer name search (case insensitive)
          customerName.includes(searchTermLower) ||

          // Partner name search (case insensitive)
          partnerName.includes(searchTermLower) ||

          // Receipt number search
          receiptNumber.includes(searchTermLower) ||

          // Amount search (exact match)
          amount.includes(searchTerm) ||

          // Date search (supports multiple formats)
          date.includes(searchTerm) || // "2025-06-11" matches "06-11"
          date.replace(/-/g, '').includes(searchTerm.replace(/-/g, '')) || // "20250611" matches "0611"
          date.split('-').some(part => part.includes(searchTerm)) // "2025" or "06" matches
        );
      } else {
        return true;
      }
    });
  };

  const fetchReceiptDetails = async () => {
    try {
      setLoading(true);
      const response = await sendApiRequest(`api/packages/all_manual/receipts?isCommissionReceipt=false`, {}, 'GET');

      if (response.status === 200) {
        const reversePlots = response.data.data.receipts.reverse()
        setReceipts(reversePlots);
        // const businessReceipts = response.data.data.receipts.filter(receipt => receipt.isCommissionReceipt === false);
        setFilteredReceipts(reversePlots);
      } else {
        toast.error(response.data.message || 'Failed to fetch receipt details');
      }
    } catch (error) {
      console.error('Error fetching receipt details:', error);
      toast.error('Failed to fetch receipt details');
    } finally {
      setLoading(false);
    }
  };
  const fetchReceiptDetailsCommision = async (receiptId) => {
    try {
      setLoading(true);
      const response = await sendApiRequest(`api/packages/all_manual/receipts?id=${receiptId}`, {}, 'GET');

      if (response.status === 200) {
        return response.data.data.receipts;
      } else {
        toast.error(response.data.message || 'Failed to fetch receipt details');
      }
    } catch (error) {
      console.error('Error fetching receipt details:', error);
    } finally {
      setLoading(false);
    }
  };

  // Pagination logic
  const indexOfLastReceipt = currentPage * receiptsPerPage;
  const indexOfFirstReceipt = indexOfLastReceipt - receiptsPerPage;
  const currentReceipts = filteredReceipts.slice(indexOfFirstReceipt, indexOfLastReceipt);
  const totalPages = Math.ceil(filteredReceipts.length / receiptsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const fetchRegularReceiptDetails = async (receipt) => {
    try {
      setLoading(true);
      const response = await sendApiRequest(`api/packages/admin/receipt/${receipt._id}`, {}, 'GET');
      setDetailedReceipt(response.data);
    } catch (error) {
      console.error('Error fetching receipt details:', error);
      toast.error('Failed to fetch receipt details');
      setDetailedReceipt(receipt); // Fallback to original receipt data
    } finally {
      setLoading(false);
    }
  };

  const handleSelectReceipt = (receipt) => {

    if (paymentReceiptFromOnce) {
      const printDataSingleReceipt = JSON.parse(paymentReceiptFromOnce)
      // console.log('sjkds',printDataSingleReceipt)
      const payload = {
        _id: printDataSingleReceipt._id,
        package: printDataSingleReceipt.package,
        customer: printDataSingleReceipt.customer,
        partner: printDataSingleReceipt.partner,
        amount: printDataSingleReceipt.totalAmount,
        amountInWords: printDataSingleReceipt.amountInWords,
        balance_amount: printDataSingleReceipt.remainingAmount,
        receiptDate: printDataSingleReceipt.date,
        receiptNumber: printDataSingleReceipt.receiptNumber,
        paid_amount: printDataSingleReceipt.amount,
        paymentDetails: printDataSingleReceipt.paymentDetails,
        paymentMode: printDataSingleReceipt.paymentMode,
        remarks: printDataSingleReceipt.remarks
      }
      setSelectedReceipt(payload);
      setDetailedReceipt(payload);
    } else {
      setSelectedReceipt(receipt);
      setDetailedReceipt(receipt);
    }
  };

  const handlePrint = () => {
    if (!detailedReceipt) {
      toast.error('No receipt selected');
      return;
    }
    window.print();
  };


  const handleDeleteReceipt = async (id) => {
    try {
      setLoading(true);
      const response = await sendApiRequest(`api/packages/all_manual/receipt/${id}`, {}, 'DELETE');
      // setDetailedReceipt(response.data);
      toast.success('Receipt deleted successfully');
      fetchReceiptDetails();
    } catch (error) {
      console.error('Error fetching receipt details:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    if (selectedReceipt) {
      setSelectedReceipt(null);
      setDetailedReceipt(null);
      localStorage.removeItem('paymentReceiptFromOnce');

      // navigate('/admin/packages/view-receipt');
      navigate(userData?.email === "prayagproperties2020@gmail.com" ? '/admin/packages/view-receipt' : '/dashboard');
    } else {
      localStorage.removeItem('paymentReceiptFromOnce');
      navigate(userData?.email === "prayagproperties2020@gmail.com" ? '/admin/packages/view-receipt' : '/dashboard');
    }
  };



  // Function to handle PDF download
  const handleDownload = () => {
    if (!detailedReceipt) return;

    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
      compress: true
    });

    // Page dimensions
    const pageWidth = 210;
    const pageHeight = 297;
    const leftMargin = 15;
    const rightMargin = 15;
    const topMargin = 15;
    const sectionGap = 8;
    const lineHeight = 5;
    const columnWidth = (pageWidth - leftMargin - rightMargin) / 2;

    // Set default font
    doc.setFont('helvetica');
    doc.setFontSize(10);

    // Add border
    doc.setDrawColor(41, 128, 185);
    doc.setLineWidth(0.5);
    doc.rect(10, 10, pageWidth - 20, pageHeight - 20);

    // Header Section
    try {
      // Logo (centered, larger)
      const logoImg = new Image();
      logoImg.src = logo;
      const logoWidth = 60;
      const logoHeight = 30;
      doc.addImage(logo, 'PNG', (pageWidth - logoWidth) / 2, topMargin, logoWidth, logoHeight);
    } catch (error) {
      console.error('Error adding logo:', error);
    }

    // Company Details (centered)
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.setTextColor(41, 128, 185);
    doc.text(companyInfo.name, pageWidth / 2, topMargin + 40, { align: 'center' });

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.text(companyInfo.division, pageWidth / 2, topMargin + 46, { align: 'center' });
    doc.text(companyInfo.address, pageWidth / 2, topMargin + 52, { align: 'center' });
    doc.text(`Phone: ${companyInfo.phone} | Email: ${companyInfo.email}`, pageWidth / 2, topMargin + 58, { align: 'center' });

    // Invoice Title (centered)
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setTextColor(41, 128, 185);
    doc.text(companyInfo.invoiceLabel, pageWidth / 2, topMargin + 68, { align: 'center' });

    // Main Content Section
    let y = topMargin + 78;

    // Customer Details (Left Column)
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.text('Customer Details:', leftMargin, y);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.text(`Name: ${detailedReceipt.customer?.customerName || ''}`, leftMargin, y + lineHeight);
    doc.text(`Phone: ${detailedReceipt.customer?.customerPhone || ''}`, leftMargin, y + lineHeight * 2);
    doc.text(`Email: ${detailedReceipt.customer?.customerEmail || ''}`, leftMargin, y + lineHeight * 3);

    // Referral Details (Right Column)
    doc.setFont('helvetica', 'bold');
    doc.text('Referral Details:', leftMargin + columnWidth, y);
    doc.setFont('helvetica', 'normal');
    doc.text(`Name: ${detailedReceipt.partner?.fullName || ''}`, leftMargin + columnWidth, y + lineHeight);
    doc.text(`Phone: ${detailedReceipt.partner?.phone || ''}`, leftMargin + columnWidth, y + lineHeight * 2);
    doc.text(`Email: ${detailedReceipt.partner?.email || ''}`, leftMargin + columnWidth, y + lineHeight * 3);

    // Invoice Details (Right Column, below referral)
    y += lineHeight * 5;
    doc.setFont('helvetica', 'bold');
    doc.text('Invoice Details:', leftMargin + columnWidth, y);
    doc.setFont('helvetica', 'normal');
    doc.text(`Booking: ${detailedReceipt.package?.title || ''}`, leftMargin + columnWidth, y + lineHeight);
    doc.text(`Referral Code: ${detailedReceipt.partner?.sponsorCode || ''}`, leftMargin + columnWidth, y + lineHeight * 2);
    doc.text(`Invoice No.: ${detailedReceipt.receiptNumber || ''}`, leftMargin + columnWidth, y + lineHeight * 3);
    doc.text(`Invoice Date: ${detailedReceipt.receiptDate ? new Date(detailedReceipt.receiptDate).toLocaleDateString('en-IN') : ''}`, leftMargin + columnWidth, y + lineHeight * 4);

    // Description Block (Left Column, below customer)
    doc.setFont('helvetica', 'bold');
    doc.text('DESCRIPTION', leftMargin, y);
    doc.setFont('helvetica', 'normal');
    doc.text(`Plot: ${detailedReceipt.package?.title || ''}, ${detailedReceipt.package?.location || ''}`, leftMargin, y + lineHeight);
    doc.text(`Plot No: ${detailedReceipt.package?.plotNumber || ''}`, leftMargin, y + lineHeight * 2);
    doc.text(`Size: ${detailedReceipt.package?.width || ''}x${detailedReceipt.package?.length || ''}`, leftMargin, y + lineHeight * 3);

    // Amount Details (Left Column, below description)
    y += lineHeight * 6;
    doc.setFont('helvetica', 'bold');
    doc.text('Amount Details:', leftMargin, y);
    doc.setFont('helvetica', 'normal');
    doc.text(`TOTAL AMOUNT: ${parseFloat(detailedReceipt.amount).toLocaleString()}`, leftMargin, y + lineHeight);
    doc.text(`PAID AMOUNT: ${parseFloat(detailedReceipt.paid_amount).toLocaleString()}`, leftMargin, y + lineHeight * 2);
    doc.text(`TOTAL BALANCE AMOUNT: ${parseFloat(detailedReceipt.balance_amount).toLocaleString()}`, leftMargin, y + lineHeight * 3);
    doc.text(`TOTAL RECEIVED AMOUNT: ${parseFloat(detailedReceipt.amount - detailedReceipt.balance_amount).toLocaleString()}`, leftMargin, y + lineHeight * 4);
    doc.text(`Total Amount in words: ${detailedReceipt.amountInWords || ''}`, leftMargin, y + lineHeight * 5);

    // Watermark
    doc.setGState(new doc.GState({ opacity: 0.07 }));
    try {
      const logoImg = new Image();
      logoImg.src = logo;
      doc.addImage(logoImg, 'PNG', pageWidth / 2 - 45, 120, 90, 50);
    } catch (error) { }
    doc.setGState(new doc.GState({ opacity: 1 }));

    // Signature Area (centered at bottom)
    const signY = pageHeight - 40;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.text('RECEIVED (in RS.)', pageWidth / 2, signY, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(`${parseFloat(detailedReceipt.paid_amount).toLocaleString()}`, pageWidth / 2, signY + 6, { align: 'center' });
    doc.setFontSize(9);
    doc.text('Authorised Signatory', pageWidth / 2, signY + 20, { align: 'center' });

    // Save PDF
    doc.save(`Receipt_${detailedReceipt.receiptNumber || 'Unknown'}_${new Date().toISOString().split('T')[0]}.pdf`);
  };





  const renderReceiptDetails = () => {
    if (!detailedReceipt) return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center max-w-md p-8 bg-white rounded-2xl shadow-lg border border-gray-100">
          <div className="mx-auto h-24 w-24 text-gray-400 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-gray-700 mb-2">No Receipt Selected</h3>
          <p className="text-gray-500 mb-6">Please select a receipt to view detailed information</p>
          <button
            onClick={() => setDetailedReceipt(null)}
            className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors duration-200"
          >
            Back to Receipts
          </button>
        </div>
      </div>
    );

    const customerName = detailedReceipt.customer?.customerName || 'N/A';
    const customerEmail = detailedReceipt.customer?.customerEmail || 'N/A';
    const customerPhone = detailedReceipt.customer?.customerPhone || 'N/A';
    const agentName = detailedReceipt.partner?.fullName || 'N/A';
    const agentEmail = detailedReceipt.partner?.email || 'N/A';
    const agentPhone = detailedReceipt.partner?.phone || 'N/A';
    const agentCode = detailedReceipt.partner?.sponsorCode || 'N/A';
    const packageDimensions = detailedReceipt.package
      ? `${detailedReceipt.package.width}x${detailedReceipt.package.length}`
      : 'N/A';
    const purchaseDate = detailedReceipt.receiptDate
      ? new Date(detailedReceipt.receiptDate).toLocaleDateString('en-IN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
      : 'N/A';
    const receiptNumber = detailedReceipt?.receiptNumber || 'N/A';

    return (
      <div className="relative">
        {/* Floating action buttons */}
        <div className="absolute -top-4 right-4 z-10 flex space-x-2">
          <button
            onClick={() => {
              setDetailedReceipt(null)
              navigate(userData?.email === "prayagproperties2020@gmail.com" ? '/admin/packages/view-receipt' : '/dashboard');
            }}
            className="p-2 bg-white rounded-full shadow-md hover:bg-gray-50 transition-colors duration-200 text-gray-600 hover:text-blue-600"
            title="Close"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Receipt Container */}
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-200 max-w-4xl mx-auto receipt-container receipt-details">
          {/* Header with decorative elements */}
          <div className="relative bg-gradient-to-r from-indigo-900 to-blue-800 text-white px-8 py-6 overflow-hidden">
            {/* Decorative elements */}
            <div className="absolute top-0 left-0 w-full h-full opacity-10">
              <div className="absolute top-0 right-0 w-32 h-32 bg-blue-400 rounded-full filter blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-indigo-400 rounded-full filter blur-3xl"></div>
            </div>

            <div className="relative z-10 flex flex-col md:flex-row justify-between items-start md:items-center">
              <div>
                <h1 className="text-3xl font-bold mb-2">Payment Receipt</h1>
                <p className="text-blue-200 font-medium">Transaction Confirmation</p>
              </div>
              <div className="mt-4 md:mt-0 bg-white bg-opacity-20 backdrop-filter backdrop-blur-sm px-4 py-3 rounded-lg">
                <p className="text-blue-100 text-sm font-medium">Receipt No.</p>
                <p className="font-bold text-xl tracking-wide">{receiptNumber}</p>
              </div>
            </div>
          </div>

          {/* Receipt Content */}
          <div className="p-6 md:p-8">
            <div className="max-w-5xl mx-auto">
              {/* Company & Customer Info */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                {/* Company Info */}
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-100 relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-16 h-16 bg-blue-200 opacity-10 rounded-bl-full"></div>
                  <div className="flex items-center mb-4">
                    <div className="bg-white p-2 rounded-lg shadow-sm mr-4">
                      <img src={logo} alt="Company Logo" className="h-10 object-contain" />
                    </div>
                    <div>
                      <h2 className="text-xl font-bold text-gray-800">Prayag Properties & Mishra Constructions</h2>
                      <p className="text-sm text-blue-600">Official Receipt</p>
                    </div>
                  </div>
                  <div className="space-y-2 text-sm text-gray-700">
                    <p className="flex items-start">
                      <svg className="w-4 h-4 mr-2 mt-0.5 text-blue-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      567, Shaha Urf Pipalgaon,
                      Near IIIT-A Chauraha,
                      Jhalwa, Prayagraj
                      211012
                    </p>
                    <p className="flex items-center">
                      <svg className="w-4 h-4 mr-2 text-blue-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                      prayagproperties2020@gmail.com
                    </p>
                  </div>
                </div>

                {/* Customer Info */}
                <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl border border-gray-200 relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-16 h-16 bg-gray-200 opacity-10 rounded-bl-full"></div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                    <svg className="w-5 h-5 mr-2 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                    Customer Details
                  </h3>
                  <div className="space-y-3 text-sm text-gray-700">
                    <div className="flex">
                      <span className="font-medium w-24 text-gray-600 flex-shrink-0">Name:</span>
                      <span className="font-medium">{customerName}</span>
                    </div>
                    <div className="flex">
                      <span className="font-medium w-24 text-gray-600 flex-shrink-0">Email:</span>
                      <span className="text-blue-600">{customerEmail}</span>
                    </div>
                    <div className="flex">
                      <span className="font-medium w-24 text-gray-600 flex-shrink-0">Phone:</span>
                      <span>{customerPhone}</span>
                    </div>
                  </div>
                </div>

                {/* Agent Info */}
                <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-xl border border-purple-100 relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-16 h-16 bg-purple-200 opacity-10 rounded-bl-full"></div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                    <svg className="w-5 h-5 mr-2 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    Reference Details
                  </h3>
                  <div className="space-y-3 text-sm text-gray-700">
                    <div className="flex">
                      <span className="font-medium w-24 text-gray-600 flex-shrink-0">Name:</span>
                      <span className="font-medium">{agentName}</span>
                    </div>
                    <div className="flex">
                      <span className="font-medium w-24 text-gray-600 flex-shrink-0">Email:</span>
                      <span className="text-purple-600">{agentEmail}</span>
                    </div>
                    <div className="flex">
                      <span className="font-medium w-24 text-gray-600 flex-shrink-0">Phone:</span>
                      <span>{agentPhone}</span>
                    </div>
                    <div className="flex">
                      <span className="font-medium w-24 text-gray-600 flex-shrink-0">Sponsor ID:</span>
                      <span className="font-mono bg-purple-100 px-2 py-0.5 rounded text-purple-800">{agentCode}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Payment Details Section */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                {/* Payment Summary */}
                <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-xl border border-green-100 relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-16 h-16 bg-green-200 opacity-10 rounded-bl-full"></div>
                  <h3 className="text-lg font-semibold text-green-800 mb-4 flex items-center">
                    <FaRupeeSign />
                    Payment Summary
                  </h3>
                  <div className="space-y-4">
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">Total Amount:</span>
                      <span className="font-bold text-green-700 text-lg">{parseFloat(detailedReceipt.amount).toLocaleString('en-IN')}</span>
                    </div>
                    {!detailedReceipt.isCommissionReceipt && <><div className="flex justify-between items-center">
                      <span className="text-gray-600">Paid Amount:</span>
                      <span className="font-bold text-green-700 text-lg">{parseFloat(detailedReceipt.paid_amount).toLocaleString('en-IN')}</span>
                    </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600">Total Balance Amount:</span>
                        <span className="font-bold text-green-700 text-lg">{parseFloat(detailedReceipt.balance_amount).toLocaleString('en-IN')}</span>
                      </div></>}
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">Total Received Amount:</span>
                      <span className="font-bold text-green-700 text-lg">{parseFloat(detailedReceipt.amount - detailedReceipt.balance_amount).toLocaleString('en-IN')}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">Total Amount in words:</span>
                      <span className="font-bold text-green-700 text-sm">{detailedReceipt.amountInWords || ''}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Payment Mode:</span>
                      <span className="font-medium capitalize bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs">
                        {detailedReceipt.paymentMode}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Date:</span>
                      <span className="font-medium">
                        {new Date(detailedReceipt.receiptDate).toLocaleDateString('en-IN', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric'
                        })}
                      </span>
                    </div>
                    {detailedReceipt.paymentDetails && (
                      <div className="pt-3 mt-3 border-t border-green-200">
                        <p className="text-sm text-gray-600 mb-1">Payment Details:</p>
                        <p className="text-sm font-medium bg-white p-2 rounded border border-green-200">
                          {detailedReceipt.paymentDetails}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Package Details */}
                <div className="bg-gradient-to-br site-details  from-indigo-50 to-indigo-100 p-3 rounded-xl border border-indigo-100 relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-16 h-16 bg-indigo-200 opacity-10 rounded-bl-full"></div>
                  <h3 className="text-lg font-semibold text-indigo-800 mb-4 flex items-center">
                    <svg className="w-5 h-5 mr-2 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                    </svg>
                    Site Details
                  </h3>
                  <div className="space-y-1 ">
                    <div className="flex justify-between gap-4">
                      <p className="text-gray-600">Package:</p>
                      <span className="font-medium text-indigo-800">{detailedReceipt.package?.title || 'N/A'} </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Dimensions:</span>
                      <span className="font-mono bg-indigo-100 text-indigo-800 px-2 py-0.5 rounded text-sm">
                        {packageDimensions}
                      </span>
                    </div>
                    <div className="flex justify-between ">
                      <span className="text-gray-600">Purchase Date:</span>
                      <span>{purchaseDate}</span>
                    </div>
                  </div>
                </div>

              </div>

              {/* Remarks Section */}
              {detailedReceipt.remarks && (
                <div className="mb-8 gap-6 ">
                  <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl border border-blue-200">
                    <h3 className="text-lg font-semibold text-blue-800 mb-3 flex items-center">
                      <svg className="w-5 h-5 mr-2 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                      </svg>
                      Remarks
                    </h3>
                    <p className="text-gray-700 bg-white p-8 rounded border border-blue-200">
                      {detailedReceipt.remarks}
                    </p>
                  </div>
                </div>
              )}

              {/* Signature & Confirmation */}
              <div className=" border-t border-gray-200">
                <div className="flex flex-col md:flex-row items-center justify-between">
                  <div className="print">
                    <p className="text-gray-500 text-sm">For Prayag Properties & Mishra Constructions</p>
                    <div className="">
                      <div className="w-24 h-0.2 bg-gray-300"></div>
                      <p className="text-gray-600 text-sm">Authorized Signatory</p>
                    </div>
                  </div>
                  <div className="bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg shadow-lg w-full md:w-full">
                    <div className="text-center space-y-2">
                      <p className="font-bold uppercase text-sm tracking-wider opacity-90">Payment Verified</p>
                      <p className="text-3xl font-bold">
                        {detailedReceipt.isCommissionReceipt
                          ? parseFloat(detailedReceipt.amount).toLocaleString('en-IN')
                          : parseFloat(detailedReceipt.paid_amount).toLocaleString('en-IN')}
                      </p>
                      <p className="text-xs opacity-80">
                        {new Date(detailedReceipt.receiptDate).toLocaleDateString('en-IN', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric'
                        })}
                      </p>
                      <span className="text-sm mt-4 opacity-90">
                        This is an official receipt. Thank you for your payment.
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderReceiptsTable = (receipts, type) => {
    const currentReceipts = receipts.slice(indexOfFirstReceipt, indexOfLastReceipt);
    if (currentReceipts.length === 0) return (
      <div className="bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="text-gray-500 text-lg mb-4">No receipts found</div>
        <div className="text-gray-400">Try adjusting your search or filters</div>
      </div>
    );

    return (
      <div className="bg-white rounded-xl shadow-lg overflow-hidden mb-8 transition-all duration-300 hover:shadow-xl">
        {/* Header with gradient and subtle animation */}
        <div className={`bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-6 py-4 transition-all duration-300 hover:from-emerald-600 hover:to-teal-700`}>
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-bold tracking-tight">Receipts Overview</h2>
            <div className="flex items-center space-x-4">
              <div className="text-emerald-100 bg-emerald-700 bg-opacity-30 px-3 py-1 rounded-full text-sm font-medium">
                {currentReceipts.length} {currentReceipts.length === 1 ? 'receipt' : 'receipts'}
              </div>
              <CSVLink
                data={filteredReceipts.map(receipt => ({
                  'Receipt Number': receipt.receiptNumber,
                  'Customer Name': receipt.customer?.customerName || 'N/A',
                  'Customer Email': receipt.customer?.customerEmail || 'N/A',
                  'Agent Name': receipt.partner?.fullName || 'N/A',
                  'Agent Email': receipt.partner?.email || 'N/A',
                  'Agent Code': receipt.partner?.sponsorCode || 'N/A',
                  'Generated Manually': receipt.generatedManually ? 'Yes' : 'No',
                  'Is Commission': receipt.isCommissionReceipt ? 'Yes' : 'No',
                  'Amount': parseFloat(receipt.amount).toLocaleString('en-IN'),
                  'Paid Amount': parseFloat(receipt.paid_amount).toLocaleString('en-IN'),
                  'Balance Amount': parseFloat(receipt.balance_amount).toLocaleString('en-IN'),
                  'Date': new Date(receipt.receiptDate).toLocaleDateString('en-IN', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric'
                  })
                }))}
                filename={`receipts_${new Date().toISOString().split('T')[0]}.csv`}
                className="text-white hover:text-emerald-100 transition-colors duration-200 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 rounded-lg shadow"
              >
                All Receipts Export CSV
              </CSVLink>
            </div>
          </div>
        </div>

        {/* Table container with smooth scrolling */}
        <div className="overflow-x-auto transition-all duration-300">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {[
                  "Receipt No.",
                  "Customer",
                  "Agent",
                  "Manual",
                  "Receipt Type",
                  "Total Amount",
                  "Paid Amount",
                  "Balance Amount",
                  "Date",
                  "Actions"
                ].map((header) => (
                  <th
                    key={header}
                    className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider group"
                  >
                    <div className="flex items-center">
                      {header}
                      {header !== "Actions" && (
                        <svg className="ml-1 h-4 w-4 text-gray-400 group-hover:text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity"
                          fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                        </svg>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody className="bg-white divide-y divide-gray-200">
              {currentReceipts.map((receipt) => (
                receipt.isCommissionReceipt === false && (
                  <tr
                    key={receipt._id}
                    className="transition-all duration-150 hover:bg-gray-50 active:bg-gray-100"
                  >
                    {/* Receipt Number */}
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 h-8 w-8 bg-emerald-100 rounded-full flex items-center justify-center mr-3">
                          <svg className="h-5 w-5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                        </div>
                        <div className="text-sm font-medium text-emerald-600">
                          {receipt.receiptNumber}
                        </div>
                      </div>
                    </td>

                    {/* Customer */}
                    <td className="px-6 py-4">
                      <div className="text-sm text-gray-900 font-medium">{receipt.customer?.customerName || 'N/A'}</div>
                      <div className="text-sm text-gray-500">{receipt.customer?.customerEmail || 'N/A'}</div>
                    </td>

                    {/* Agent */}
                    <td className="px-6 py-4">
                      <div className="text-sm text-gray-900 font-medium">{receipt.partner?.fullName || 'N/A'}</div>
                      <div className="text-sm text-gray-500">{receipt.partner?.email || 'N/A'}</div>
                      {receipt.partner?.sponsorCode && (
                        <div className="text-xs text-gray-400 mt-1">
                          Code: <span className="font-mono bg-gray-100 px-1 rounded">{receipt.partner.sponsorCode}</span>
                        </div>
                      )}
                    </td>

                    {/* Manually Generated */}
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full 
          ${receipt.generatedManually ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'}`}>
                        {receipt.generatedManually ? 'Manual' : 'Auto'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full 
          ${receipt.isCommissionReceipt ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'}`}>
                        {receipt.isCommissionReceipt ? 'Commission' : 'Original'}
                      </span>
                    </td>

                    {/* Amount */}
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-bold text-gray-900">
                        {parseFloat(receipt.amount).toLocaleString('en-IN')}
                      </div>
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-bold text-gray-900">
                        {parseFloat(receipt.paid_amount).toLocaleString('en-IN')}
                      </div>
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-bold text-gray-900">
                        {parseFloat(receipt.balance_amount).toLocaleString('en-IN')}
                      </div>
                    </td>



                    {/* Date */}
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">
                        {new Date(receipt.receiptDate).toLocaleDateString('en-IN', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric'
                        })}
                      </div>
                    </td>

                    {/* Actions */}
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <div className="flex items-center justify-end space-x-4">
                        {/* View All Receipts Button */}
                        {receipt?.customer?.paymentHistory.length > 0 && <button
                          onClick={() => navigate(`/admin/payment/history?customerId=${receipt.customer._id}&packageId=${receipt.package._id}`)}
                          className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 transition-all duration-200"
                          aria-label={`View all receipts for ${receipt.receiptNumber}`}
                          title="View complete receipt history"
                        >
                          All Receipts
                          <svg
                            className="ml-1.5 h-3 w-3"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M14 5l7 7m0 0l-7 7m7-7H3"
                            />
                          </svg>
                        </button>}


                        {/* View Details Button */}
                        {receipt?.customer?.paymentHistory.length <= 0 && <button
                          onClick={() => handleSelectReceipt(receipt)}
                          className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 transition-all duration-200"
                          aria-label={`View details for receipt ${receipt.receiptNumber}`}
                          title="View receipt details"
                        >
                          Details
                          <svg
                            className="ml-1.5 h-3 w-3"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </button>}


                        {/* Delete Button */}
                        <button
                          onClick={() => handleDeleteReceipt(receipt._id)}
                          className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-200"
                          aria-label={`Delete receipt ${receipt.receiptNumber}`}
                          title="Delete this receipt"
                        >
                          Delete
                          <svg
                            className="ml-1.5 h-3 w-3"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            />
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                )
              ))}
            </tbody>
          </table>
        </div>

        {/* Enhanced Pagination */}
        {currentReceipts.length > 0 && (
          <div className="flex flex-col sm:flex-row items-center justify-between px-6 py-4 bg-gray-50 border-t border-gray-200">
            <div className="text-sm text-gray-600 mb-4 sm:mb-0">
              Showing <span className="font-semibold text-gray-900">{indexOfFirstReceipt + 1}</span> to{' '}
              <span className="font-semibold text-gray-900">
                {Math.min(indexOfLastReceipt, receipts.length)}
              </span>{' '}
              of <span className="font-semibold text-gray-900">{receipts.length}</span> entries
            </div>
            <div className="flex space-x-2">
              <button
                onClick={() => paginate(Math.max(1, currentPage - 1))}
                disabled={currentPage === 1}
                className={`px-4 py-2 rounded-md flex items-center transition-all duration-200 ${currentPage === 1
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                  : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 hover:border-gray-400 shadow-sm'
                  }`}
              >
                <FiChevronLeft className="inline mr-1" />
                Previous
              </button>
              <div className="flex items-center space-x-1">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
                  <button
                    key={number}
                    onClick={() => paginate(number)}
                    className={`w-10 h-10 rounded-md flex items-center justify-center transition-all duration-200 ${currentPage === number
                      ? 'bg-emerald-600 text-white shadow-md'
                      : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 hover:border-gray-400'
                      }`}
                  >
                    {number}
                  </button>
                ))}
              </div>
              <button
                onClick={() => paginate(Math.min(totalPages, currentPage + 1))}
                disabled={currentPage === totalPages}
                className={`px-4 py-2 rounded-md flex items-center transition-all duration-200 ${currentPage === totalPages
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                  : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 hover:border-gray-400 shadow-sm'
                  }`}
              >
                Next
                <FiChevronRight className="inline ml-1" />
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  if (loading && !detailedReceipt) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-600 mb-4"></div>
          <p className="text-gray-600">Loading receipt details...</p>
        </div>
      </div>
    );
  }

  if (!receipts.length) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
        <div className="bg-white p-8 rounded-xl shadow-lg text-center max-w-md">
          <div className="text-red-500 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">No Receipts Found</h2>
          <p className="text-gray-600 mb-6">There are no receipts available to display.</p>
          <button
            onClick={handleBack}
            className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-lg font-medium hover:from-blue-700 hover:to-blue-900 transition-all shadow-md hover:shadow-lg"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Action Bar */}
        <div className="flex flex-col gap-4 mb-8">
          <div className="flex justify-between items-center">
            <button onClick={handleBack} className="flex items-center space-x-2 px-4 py-2 bg-white rounded-lg shadow-sm hover:bg-gray-100 transition-colors border border-gray-200">
              <FiArrowLeft className="text-blue-600" />
              <span className="font-medium text-gray-700">Back</span>
            </button>
            {detailedReceipt ? (
              <div className="flex space-x-3">
                <button onClick={handleDownload} className="flex items-center space-x-2 px-4 py-2 bg-white rounded-lg shadow-sm hover:bg-gray-100 transition-colors border border-gray-200">
                  <FiDownload className="text-blue-600" />
                  <span className="font-medium text-gray-700">Download</span>
                </button>
                <button
                  onClick={handlePrint}
                  className="flex items-center space-x-2 px-4 py-2 bg-white rounded-lg shadow-sm hover:bg-gray-100 transition-colors border border-gray-200"
                  disabled={!detailedReceipt}
                >
                  <FiPrinter className="text-blue-600" />
                  <span className="font-medium text-gray-700">Print</span>
                </button>
              </div>
            ) : null}
          </div>

          {!detailedReceipt && (
            <div className="w-full">
              <div className="flex flex-col md:flex-row gap-4">
                <div className="relative flex-1">
                  <input
                    type="text"
                    placeholder="Search receipts..."
                    className="w-full px-4 py-2 pl-10 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <FiSearch className="absolute left-3 top-3 text-gray-400" />
                </div>
                <select
                  className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white min-w-[180px]"
                  value={monthFilter}
                  onChange={(e) => setMonthFilter(e.target.value)}
                >
                  <option value="">All Months</option>
                  {Array.from({ length: 12 }, (_, i) => ({
                    value: i + 1,
                    label: new Date(0, i).toLocaleString('default', { month: 'long' })
                  })).map(month => (
                    <option key={month.value} value={month.value}>
                      {month.label}
                    </option>
                  ))}
                </select>
                <select
                  className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white min-w-[120px]"
                  value={yearFilter}
                  onChange={(e) => setYearFilter(e.target.value)}
                >
                  <option value="">All Years</option>
                  {Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i).map(year => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
                <button
                  onClick={() => {
                    setMonthFilter('');
                    setYearFilter('');
                    setSearchTerm('');
                  }}
                  className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors text-gray-700 font-medium whitespace-nowrap"
                >
                  Reset Filters
                </button>
                {/* <CSVLink
                  data={csvData}
                  filename={`receipts_export_${new Date().toISOString().split('T')[0]}.csv`}
                  className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors font-medium whitespace-nowrap"
                >
                  <FiFileText className="inline" />
                  Export to CSV
                </CSVLink> */}
              </div>
            </div>
          )}
        </div>

        {detailedReceipt ? (
          renderReceiptDetails()
        ) : (
          <>
            {renderReceiptsTable(filteredReceipts, 'manual')}
            {/* {renderReceiptsTable(filteredReceipts, 'regular')} */}
          </>
        )}
      </div>
    </div>
  );
};

export default ViewPackageReceipt;